import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { browserTracingIntegration, init as initSentry, replayIntegration } from "@sentry/remix";
import { startTransition, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

import { getLocaleProvider } from "~/utils/i18n/i18n-loader";

import * as React from "react";
import { clientEnv } from ".env/.browser";

initSentry({
  environment: clientEnv.CLIENT_APP_ENV,
  dsn: clientEnv.CLIENT_SENTRY_DNS,
  tracesSampleRate: 1,
  integrations: [
    browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    replayIntegration({
      maskAllText: false,
      blockAllMedia: true,
    }),
  ],
  ignoreErrors: [/Failed to fetch dynamically imported module: https:\/\/.*\/assets\/.*\.js/],

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});

const LocaleProvider = getLocaleProvider();

const remixBrowser = (
  <React.StrictMode>
    <LocaleProvider>
      <RemixBrowser />
    </LocaleProvider>
  </React.StrictMode>
);

startTransition(() => {
  hydrateRoot(document, remixBrowser);
});
